module.exports = require("./es-EC.d.ts");